import React from 'react';
import { REACT_APP_API_URL } from "../config";

const { REACT_APP_SERVER } = process.env;
const BootstrapCarousel = ({ images }) => {
    let link = REACT_APP_API_URL + ((REACT_APP_SERVER === 'Ucom' || REACT_APP_SERVER === 'V-office') ? '/rest' : '');

    return (
        <>
            <style>
                {`
          .carousel-control-prev-icon,
          .carousel-control-next-icon {
            background-image: none;
            width: 2rem;
            height: 2rem;
            border: solid #818181;
            border-width: 0 3px 3px 0;
            display: inline-block;
            padding: 5px;
          }
          .carousel-control-prev-icon {
            transform: rotate(135deg);
          }
          .carousel-control-next-icon {
            transform: rotate(-45deg);
          }
          .carousel-indicators [data-bs-target] {
            background-color: #818181;
          }
        `}
            </style>

            <div id="myCarousel" className="carousel slide" data-bs-ride="carousel">
                {/* Indicators */}
                <div className="carousel-indicators">
                    {images.map((_, idx) => (
                        <button
                            key={idx}
                            type="button"
                            data-bs-target="#myCarousel"
                            data-bs-slide-to={idx}
                            className={idx === 0 ? 'active' : ''}
                            aria-current={idx === 0 ? 'true' : undefined}
                            aria-label={`Slide ${idx + 1}`}
                        />
                    ))}
                </div>

                {/* Slides */}
                <div className="carousel-inner">
                    {images.map((img, idx) => (
                        <div className={`carousel-item ${idx === 0 ? 'active' : ''}`} key={idx}>
                            <img src={link + img} className="d-block w-100" alt={`Slide ${idx}`} style={{ objectFit: 'contain', height: '300px' }} />
                        </div>
                    ))}
                </div>

                {/* Controls */}
                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#myCarousel"
                    data-bs-slide="prev"
                >
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#myCarousel"
                    data-bs-slide="next"
                >
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </>
    );
};

export default BootstrapCarousel;
